import { GTagEvents } from '@/lib/gTagManager';

export const sendEventToAppWrapper = (message: GTagEvents, params?: unknown): void => {
  // this if checks if the window has a parent, and if that parent is not itself, and if the parent has a postMessage method
  if (window && window.parent && window.parent.postMessage) {
    window.parent.postMessage({ event_message: message, event_params: params }, '*');
  }
};
